module.exports = __webpack_public_path__ + "chief.jpg?a725abb6d835740e615b662d3c707d95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chief.jpg
// module id = 105
// module chunks = 0